import * as React from "react"

const OutlineTShirt = () =>  {
  return (
    <svg
      width={35}
      height={35}
      viewBox="0 0 1088 1024"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M724.048 7.229l360.982 128.923-59.286 207.506-207.882-23.098v687.814H246.327V320.931L61.644 344.016 3.312 110.687 364.636 7.451l5.875 1.292c69.731 15.334 123.034 22.85 175.232 22.907 52.144.057 104.237-7.33 171.507-22.853l6.797-1.568zM349.44 61.327l-288.749 82.5 36.924 147.694 196.34-24.543v693.767h476.278V267.347l220.771 24.53 35.968-125.888L738.028 62.795c-66.797 181.692-322.81 181.202-388.589-1.469zm336.016 3.005c-50.634 9.958-94.861 14.994-139.766 14.945-45.334-.05-90.694-5.282-143.341-15.337 58.192 116.043 224.675 116.173 283.107.391z"
        fill="#283948"
      />
    </svg>
  )
}

export default OutlineTShirt
